import Card from '@/components/card/card-component';
import { Col } from '@/components/grid/grid-component';
import useSelectStyle from '@/hooks/use-select-style';
import { SubheaderText } from '@/utils/global-fonts';
import PropTypes from 'prop-types';
import { MdOutlineAddCircleOutline } from 'react-icons/md';
import Select from 'react-select';
import theme from '@/common/theme';
import Styled from './quote-module-price-style';

const cardBodyStyle = {
  padding: '0px',
  display: 'flex',
  flexDirection: 'column',
};

const colStyle = {
  marginTop: '24px',
  height: 'unset',
};

/**
 * Quoting Module Details component
 * @param {object} props - props
 * @param {func} props.setOpenCreateModal - function to open modal
 * @param {func} props.setOpenEditModal - function to open modal
 * @param {func} props.setModuleIdToEdit - function to set Module to edit
 * @param {func} props.setModuleIdToDelete - function to set Module to delete
 * @param {func} props.deleteQuoteModuleHandler - function to delete Module
 * @param {Array} props.data - function to open modal
 * @returns {JSX.Element} component
 */
const QuoteModuleDetails = ({
  setOpenCreateModal,
  data,
  setModuleIdToEdit,
  setModuleIdToDelete,
  deleteQuoteModuleHandler,
  setOpenEditModal,
}) => {
  const selectStyle = useSelectStyle();
  const getOptions = (options) =>
    options.map((option) => ({
      value: option.value,
      label: option.value,
    }));

  return (
    <Styled.CardStyle bodyStyle={cardBodyStyle}>
      <Styled.RowStyle>
        <Col xs={12} md={4} style={colStyle}>
          <Card padding="24px" bodyStyle={cardBodyStyle}>
            <SubheaderText>Quote Number</SubheaderText>
            <Styled.Line />
            <Styled.LabelText>Quote Number</Styled.LabelText>
            <Styled.Container />
          </Card>
        </Col>
        {data.map((module) => (
          <Col xs={12} md={4} key={module.id} style={colStyle}>
            <Styled.ModuleCard padding="24px" bodyStyle={cardBodyStyle}>
              <Styled.HeadingDiv>
                <Styled.Title>{module.title}</Styled.Title>
                <Styled.IconDiv>
                  <Styled.EditIcon
                    color={theme.COLOR_GREY3}
                    size={16}
                    onClick={() => {
                      setOpenEditModal(true);
                      setModuleIdToEdit(module.id);
                    }}
                  />
                  <Styled.DeleteIcon
                    onClick={() => {
                      setModuleIdToDelete(module.id);
                      deleteQuoteModuleHandler();
                    }}
                    color={theme.COLOR_GREY3}
                    size={24}
                  />
                </Styled.IconDiv>
              </Styled.HeadingDiv>
              <Styled.Description>{module.description}</Styled.Description>
              <Styled.Line />
              <Select
                styles={selectStyle}
                header="Quoting Module Type"
                options={getOptions(module?.options ?? [])}
                placeholder="Options"
              />
            </Styled.ModuleCard>
          </Col>
        ))}
        <Col xs={12} md={4} style={colStyle}>
          <Styled.AddModuleCard bodyStyle={cardBodyStyle}>
            <Styled.AddModuleRow
              onClick={() => {
                setOpenCreateModal(true);
              }}
            >
              <MdOutlineAddCircleOutline color={theme.COLOR_GREY3} size={40} />
              <Styled.AddModuleText color={theme.COLOR_GREY3}>
                Add New Details Module
              </Styled.AddModuleText>
            </Styled.AddModuleRow>
          </Styled.AddModuleCard>
        </Col>
      </Styled.RowStyle>
    </Styled.CardStyle>
  );
};

QuoteModuleDetails.propTypes = {
  setOpenCreateModal: PropTypes.func.isRequired,
  setOpenEditModal: PropTypes.func.isRequired,
  setModuleIdToEdit: PropTypes.func.isRequired,
  setModuleIdToDelete: PropTypes.func.isRequired,
  deleteQuoteModuleHandler: PropTypes.func.isRequired,
  data: PropTypes.shape([]),
};

QuoteModuleDetails.defaultProps = {
  data: [],
};

export default QuoteModuleDetails;
